import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

const blacklistUrls: readonly string[] = ['visualstudio.com', 'client-info/details', 'signalr/add-to-group/'];

export const loadingInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next) => {
  const isBlacklisted = blacklistUrls.some((url: string) => request.url.includes(url));

  if (isBlacklisted) {
    return next(request);
  }

  LoadingService.show();

  return next(request).pipe(finalize(() => LoadingService.hide()));
};
